export default __webpack_public_path__ + "static/media/flag-icon-filled.5d77c1a0.svg";